// Module
var code = "<uia-rights-flow should-show-rights-options=\"model.shouldShowRightsOptions\"></uia-rights-flow> ";
// Exports
module.exports = code;